import { useEffect, useState } from "react";

export default function ScrollToTopButton() {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const onScroll = () => setShow(window.pageYOffset > 300);
    window.addEventListener("scroll", onScroll, { passive: true });
    onScroll(); // état correct au chargement
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <button
      type="button"
      aria-label="Revenir en haut"
      className={`back-to-top ${show ? "show" : ""}`}
      onClick={scrollToTop}
    >
      {/* petite flèche vers le haut en SVG (pas de dépendance) */}
      <svg width="20" height="20" viewBox="0 0 24 24" aria-hidden="true">
        <path d="M12 5l-7 7h5v7h4v-7h5z" fill="currentColor" />
      </svg>
    </button>
  );
}
